import { connect } from 'react-redux';
import React from 'react';
import * as valid from 'utils/validate';
import { bindActionCreators } from 'redux';
import { renderKBInput, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';
import { api,
apiUtils } from 'app/services';
import { dynamicAttributesActions } from 'app/actions';
import { OPPORTUNITIES_SOURCE } from 'app/constants';
import {
KBFormError,
KBButton,
KBRadio,
KBSelect,
KBPopover } from
'components';

var SpacesCrmDynamicAttributesForm = class extends React.Component {constructor(props) {super(props);this.addDynamicAttribute = this.addDynamicAttribute.bind(this);}addDynamicAttribute(

  model) {
    const { createDynamicAttributesActions, type, add } = this.props;
    model.type_scoped = 'Opportunity';
    model.datatype = type.id;
    model.default = model._default;
    delete model._default;
    return api.createDynamicAttributes(model).then(
    json => {
      add(json.response.body);
      KBPopover.close();
    },
    err => {
      createDynamicAttributesActions.failure(err);
    });

  }render()
  {
    const {
      fields: { name, pretty_name_cn, _default, is_required },
      error,
      submitting,
      handleSubmit,
      type } =
    this.props;
    const boolData = [
    { title: '是', value: true },
    { title: '否', value: false }];


    return (
      <form onSubmit={handleSubmit(this.addDynamicAttribute)}>
        <header className="kb-form-header">
          <h2 className="header-title">新增{type.name}字段</h2>
          <i
          className="iconfont header-close icon-cancel"
          onClick={KBPopover.close} />

        </header>
        <KBFormError error={this.props.error} />
        <div className="kb-form-container">
          <div className="popup-left-6">
            <div className="kb-row">
              <Field name="pretty_name_cn" component={renderKBInput}
              className="kb-form-group kb-form-alone"
              title="字段名称"

              isRequired={true}
              fistFoucs={true} />

            </div>
            <div className="kb-row">
              <Field name="name" component={renderKBInput}
              className="kb-form-group kb-form-alone"
              title="API名称"

              isRequired={true} />

            </div>
            <div className="kb-row">
              <Field name="_default" component={renderKBInput}
              className="kb-form-group kb-form-alone"
              title="默认值"

              isRequired={false} />

            </div>
            <div className="kb-row">
              <Field name="is_required" component={renderKBInput}
              className="kb-form-group kb-form-alone"
              title="是否必填"

              isRequired={false} />

            </div>
          </div>

          <div className="popup-right-4">
            <div className="kb-title" style={{ border: 0 }}>
              <span className="color-six">示例</span>
            </div>
            <div className="kb-row kb-form-group">
              <input className="kb-input" type="text" value={type.id} readOnly />
            </div>
          </div>

          <div className="kb-row t-right" style={{ marginTop: '250px' }}>
            <span className="cancel-btn" onClick={KBPopover.close}>
              取消
            </span>
            <KBButton
            className="certain-btn m-left-sm"
            style={{ marginRight: 0 }}
            type="submit"
            submitting={submitting}>

              确定
            </KBButton>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    createDynamicAttributesActions: bindActionCreators(
    dynamicAttributesActions.create,
    dispatch) };


}

const validate = values => {
  const errors = {};

  if (valid.required(values.name)) {
    errors.name = '请输入API名称';
  }

  if (valid.required(values.pretty_name_cn)) {
    errors.pretty_name_cn = '请输入字段名称';
  }

  return errors;
};

const LEGACY_FORM_FIELDS = [
  "name",
  "pretty_name_cn",
  "_default",
  "is_required"
];

const formConfig = {
  form: 'SpacesCrmDynamicAttributesForm',
  validate: validate,
  touchOnBlur: false };


export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('SpacesCrmDynamicAttributesForm', LEGACY_FORM_FIELDS)(SpacesCrmDynamicAttributesForm)));
